(function($) {

    function header_parallax(height, resized) {
    "use strict";
        var scrollPosition = $(window).scrollTop();
        var bannerOffset = $('#header').position();

        if (scrollPosition < bannerOffset.top + $("#header").outerHeight() || resized) {
            bannerOffset = bannerOffset.top / 5;
            var calcImageHeight = (height + bannerOffset);
            var scrollOffset = Math.round(scrollPosition * 0.2);

            $('#header .image').css({
                'transform':'translate3d(0,' + scrollOffset + 'px,0)',
                'top': -bannerOffset + 'px',
                'height': calcImageHeight + 'px'
            });
        }
    }

    function navigation_condense() {
        var scrollPosition = $(window).scrollTop();
        if (scrollPosition > 15) {
            $('#navigation').addClass('condensed');
            $('#mobile-navigation').addClass('condensed');
        } else {
            $('#navigation').removeClass('condensed');
            $('#mobile-navigation').removeClass('condensed');
        }
    }


    $(window).on('load', function(){
        if ($('#header').length) {
            header_parallax($('#header').outerHeight());
        }
    });

    $(window).resize(function(){
        if ($('#header').length) {
            header_parallax($('#header').outerHeight(), true);
        }
    });

    $(document).scroll(function(){
        if ($('#header').length) {
            header_parallax();
        }
        navigation_condense();
    });

})( jQuery );
